import { render } from "./PickUpComponent.vue?vue&type=template&id=0bb364c6"
import script from "./PickUpComponent.vue?vue&type=script&lang=js"
export * from "./PickUpComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__